import {Component, Input, Output, EventEmitter, AfterViewInit} from "@angular/core";
import {LoginService} from "../../login/login.service";
import {Funcoes} from "../../funcoes";
//import * as moment from 'moment';
declare let moment: any;

declare let $:any;

@Component({
  selector: 'widget-input-calendario',
  template: `<div
                [formGroup]="form"
                [class.has-error]="form.controls[id].touched && !form.controls[id].valid"
                [class.has-feedback]="form.controls[id].touched && !form.controls[id].valid">
                <label class="control-label text-right {{labelClass}}" for="{{id}}" [class.active]="model">{{ txtLabel | translate }}</label>
                <div class="{{containerInputClass}}">
                  <input type="hidden" [(ngModel)]="model" formControlName="{{id}}">
                  <input type="text" id="{{id}}" autocomplete="off" value="{{func.formatDate(tipo, model, loginService.getUserInfo(true))}}" class="form-control validate"
                  [class.input-view]="readonly"
                  [readonly]="readonly">
                  <div class="form-control-feedback" *ngIf="form.controls[id].touched && !form.controls[id].valid">
                    <i class="icon-cancel-circle2"></i>
                  </div>
                  <span class="help-block" *ngIf="form.controls[id].touched && !form.controls[id].valid && !form.controls[id].errors[id]">{{txt_default_erro}}</span>
                  <div *ngIf="!form.controls[id].valid">
                    <span class="help-block" *ngFor="let erro of form.controls[id].errors[id] | keysBack">{{ 'back.'+erro.key | translate:erro.replace }}</span>
                  </div>
                </div>
              </div>`,
})

export class WidgetInputCalendarioComponent implements AfterViewInit {

  @Input()
  id: string = '';

  @Input()
  model: any = '';

  @Output() modelChange = new EventEmitter<string>();

  @Input()
  form: any;

  @Input()
  txt_default_erro: any;

  @Input()
  txtLabel: string = '';

  @Input()
  labelClass: string = 'col-sm-2';

  @Input()
  containerInputClass: string = 'col-sm-10';

  @Input()
  readonly: boolean = false;

  @Input()
  tipo = 'data'; // date ou dateTime


  constructor(
    public loginService: LoginService,
    public func: Funcoes
  ) {

  }

  ngAfterViewInit() {
    let self = this;

    // mascara data
    this.loginService.getUserInfo()
      .subscribe(
        res => {
          let self = this;
          // corrige formato da data para o locale
          let locale = (res.idioma == 'pt')? 'pt-BR':res.idioma;
          let dbFormat = (this.tipo == 'dataHora')? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
          let dateFormat = (this.tipo == 'dataHora')? res.date_format+' HH:mm' : res.date_format;

          $('#'+self.id).datetimepicker({
            format: dateFormat,
            locale: locale
          }).on("dp.change", function(e) {
            self.model = moment(e.date).format(dbFormat);
            self.update(self.model);
          });
        },
        error => {
          this.func.showErro(error.json());
        });

  }

  update(val : string) {
    this.model = (val == 'Invalid date')?null:val;
    this.modelChange.emit(this.model);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/form/widget-input-calendario.component.ts